// ==========================================
// 1. UPDATED Home.jsx
// ==========================================
import React, { useState, useEffect } from "react";
import NewsSection from "../../components/home/NewsSection";
import Loading from "../../components/common/Loading";
import {
  fetchBharatNews,
  fetchGlobalNews,
  fetchSportsNews,
  fetchFinanceNews,
  fetchGossipNews,
} from "../../services/api";
import AppNavbar from "../../components/common/AppNavbar";
import { Helmet } from "react-helmet";
import HomeExtra from "../../components/home/HomeExtra";
import Movies from "../../components/Entertainment/Movie";

function Home() {
  const [news, setNews] = useState({
    bharat: [],
    global: [],
    sports: [],
    finance: [],
    gossip: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadNews = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch all categories in parallel
        const [bharat, global, sports, finance, gossip] = await Promise.all([
          fetchBharatNews(),
          fetchGlobalNews(),
          fetchSportsNews(),
          fetchFinanceNews(),
          fetchGossipNews(),
        ]);

        setNews({ bharat, global, sports, finance, gossip });
        // console.log("News loaded successfully:", {
        //   bharat,
        //   global,
        //   sports,
        //   finance,
        // });
      } catch (err) {
        console.error("Error loading news:", err);
        setError("Failed to load news. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    loadNews();
  }, []);

  if (loading) return <Loading />;

  if (error) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          color: "#d32f2f",
        }}
      >
        <p>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: "20px",
            padding: "10px 24px",
            background: "#0066cc",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>A platform promoting Indians/Bharatians rich heritage</title>
        <meta
          name="description"
          content="A Community Platform Connecting Indians/Bharatians nationals across the globe. Sharing news, events, and cultural insights. Building a vibrant global community."
        />
        <meta
          name="keywords"
          content="BharatAbroad,Bharat Abroad,abroad,bharat,Bharatian Global Community,Community Portal,Global Indians,Indian Events,Global Bharatian,Sports,Health,Travel,Indian Movies,News,Cultural Exchange,Indian Heritage,Global Networking,Indian Communities Abroad,Cultural Events,International News,Indian Culture,Indian Lifestyle,Travel Destinations,Health Tips,Sports Events,Movie Reviews,Indian Cinema,Travel Guides,Health Awareness,Community Engagement,Global Events,Indian Traditions,Cultural Heritage,Indian Cuisine,Festivals,Travel Experiences,Health Insights,Sports Highlights,Movie Recommendations,Community Stories,Indian Art,Indian Music,Indian Dance,Indian Literature,Indian Fashion,Indian History,Indian Architecture,Indian Philosophy,Indian Spirituality,Indian Languages,Indian Cuisine Recipes,Indian Festivals Calendar,Indian Cultural Events,Indian Cultural Organizations,Indian Cultural Institutions "
        />
        <meta
          name="keywords"
          content="Indian Cultural Heritage Sites,Indian Cultural Traditions,Indian Cultural Practices,Indian Cultural Festivals,Indian Cultural Celebrations,Indian Cultural Performances,Indian Cultural Exhibitions,Indian Cultural Programs,Indian Cultural Activities,Indian Cultural Workshops,Indian Cultural Classes,Indian Cultural Courses,Indian Cultural Seminars,Indian Cultural Conferences,Indian Cultural Symposiums,Indian Cultural Discussions,Indian Cultural Debates,Indian Cultural Dialogues,Indian Cultural Exchanges,Indian Cultural Collaborations,Indian Cultural Partnerships,Indian Cultural Initiatives,Indian Cultural Projects,Indian Cultural Campaigns,Indian Cultural Movements,Indian Cultural Organizations Abroad,Indian Cultural Communities Abroad,Indian Cultural Associations Abroad,Indian Cultural Societies Abroad,Indian Cultural Clubs Abroad,Indian Cultural Groups Abroad,Indian Cultural Networks Abroad,Indian Cultural Forums Abroad,Indian Cultural Platforms Abroad,Indian Cultural Hubs,Abroad,Indian Cultural Centers Abroad,Indian Cultural Spaces Abroad,Indian Cultural Venues Abroad,Indian Cultural Events Abroad,Indian Cultural Festivals Abroad,Indian Cultural Celebrations Abroad,Indian Cultural Performances Abroad,Indian Cultural Exhibitions Abroad,Indian Cultural Programs Abroad,Indian Cultural Activities Abroad,Indian Cultural Workshops Abroad,Indian Cultural Classes Abroad,Indian Cultural Courses Abroad,Indian Cultural Seminars Abroad,Indian Cultural Conferences Abroad,Indian Cultural Symposiums Abroad,Indian Cultural Discussions Abroad,Indian Cultural Debates Abroad,Indian Cultural Dialogues Abroad,Indian Cultural Exchanges Abroad,Indian Cultural Collaborations Abroad,Indian Cultural Partnerships Abroad ,Indian Cultural Initiatives Abroad,Indian Cultural Projects Abroad,Indian Cultural Campaigns Abroad,Indian Cultural Movements Abroad "
        />
        <meta name="robots" content="index, follow" />
        <meta
          property="og:title"
          content="Celebrating Indian Heritage and Global Community-BharatAbroad"
        />
        <meta
          property="og:description"
          content=" BharatAbroad is a global community platform dedicated to connecting Bharatians/Indians living overseas with the rich culture, heritage, and spirit of Bharat. It serves as a space for sharing local community events, stories, cultural insights, and experiences of life abroad. The YouTube channel offers Bharat’s/India’s vibrant traditions, Heritage through videos on local events, festivals, temples, local cuisine, Tourist places, Market places, and cultural practices. "
        />
        <meta property="og:url" content="https://www.bharatabroad.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayg.s3.us-east-2.amazonaws.com/bharat/IMG-20240821-WA0058.jpg"
        />
        <meta property="og:site_name" content="BharatAbroad " />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:locale" content="en_US" />
      </Helmet>
      <AppNavbar />

      <div
        style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}
      >
        <div id="container" style={{ maxWidth: "1400px", margin: "0 auto" }}>
          {/* Bharat Section */}
          <NewsSection
            title="Bharat News"
            articles={news.bharat}
            category="bharat"
          />

          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Global Section */}
          <NewsSection
            title="Global News"
            articles={news.global}
            category="global"
          />

          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Sports Section */}
          <NewsSection
            title="Sports News"
            articles={news.sports}
            category="sports"
          />
          <HomeExtra />

          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Finance Section */}
          <NewsSection
            title="Finance News"
            articles={news.finance}
            category="finance"
          />

          <hr
            style={{
              border: "none",
              borderTop: "2px solid #e0e0e0",
              margin: "40px 0",
            }}
          />

          {/* Gossipe Section */}
          <NewsSection
            title="Web Stories"
            articles={news.gossip}
            category="gossip"
          />
          {/* 
          <Movies /> */}
        </div>
      </div>
    </>
  );
}

export default Home;
